module.exports = __webpack_public_path__ + "34bc775d/img/document.e2130c6b.svg";